import { ComponentProps, useState } from "react";
import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import Modal from "@components/Modal/Modal";
import Details from "@features/taboola/components/Disclaimer/Details";
import Text from "@features/taboola/components/Disclaimer/Text";
import { cn } from "@util/helpers";

type DisclaimerProps = {
  /** The className for disclaimer component. */
  className?: string;
  /** The GA variant for the Disclaimer component. */
  gaVariant?: string;
} & Pick<ComponentProps<typeof Text>, "isArticlePage">;
/**
 * The disclaimer component for Taboola.
 * @figma https://www.figma.com/design/9RrH1KYIUOZk6rvgzlBBKX/WEB-BAU-2026?node-id=19023-42986&t=tpbpx7fCaGouWZGL-0
 */
const Disclaimer = ({
  className,
  gaVariant,
  isArticlePage = false,
}: DisclaimerProps): React.ReactElement => {
  const [isShown, setIsShown] = useState(false);

  return (
    <div
      data-testid="disclaimer-component"
      className={cn(
        "peer-empty:hidden",
        { "md:px-8": isArticlePage },
        className
      )}
    >
      <Text
        setIsShown={setIsShown}
        isArticlePage={isArticlePage}
        gaVariant={gaVariant}
      />

      <Modal
        isModalOpen={isShown}
        setIsModalOpen={setIsShown}
        dialogPanelClassNames={cn(
          "w-9/10 md:w-[30rem] rounded-[.25rem] md:rounded-[.25rem] max-h-9/10"
        )}
      >
        <ButtonFactory
          buttonType={ButtonType.Secondary}
          className="absolute right-6 top-6 border-0 p-0 text-xs"
          onClick={() => {
            setIsShown(false);
          }}
          icon={
            <IconFactory type={IconTypeEnum.close} className="text-gray-850" />
          }
        />

        <Details />
      </Modal>
    </div>
  );
};

export default Disclaimer;
